import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, bool_type, class_type, list_type, union_type, string_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { BoolResult_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Contracts.fs.js";
import { Remote$1, Remote$1_$reflection, GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { FormField__get_IsValid, ValidationRule, FormField_Init_Z1F39563A, FormField_$reflection } from "../../../../Bfs.Web.Portale/Validation.fs.js";

export class Page extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TextList", "TextEdit"];
    }
}

export function Page_$reflection() {
    return union_type("AdminText.Types.Page", [], Page, () => [[], [["key", string_type]]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadTextList", "TextListLoaded", "LoadText", "TextLoaded", "LoadMaintenanceState", "MaintenanceStateLoaded", "ContentChanged", "MaintenanceActiveChanged", "MaintenanceActiveSaved", "Save", "Saved", "GlobalMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("AdminText.Types.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(string_type), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", list_type(string_type)]], [["ErrorValue", class_type("System.Exception")]]])]], [["key", string_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [BoolResult_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", BoolResult_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", string_type]], [["Item", bool_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", GlobalMsg_$reflection()]]]);
}

export class Model extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ListModel", "ItemModel"];
    }
}

export function Model_$reflection() {
    return union_type("AdminText.Types.Model", [], Model, () => [[["Item", TextListModel_$reflection()]], [["Item", TextEditModel_$reflection()]]]);
}

export class TextListModel extends Record {
    constructor(TextInfoList) {
        super();
        this.TextInfoList = TextInfoList;
    }
}

export function TextListModel_$reflection() {
    return record_type("AdminText.Types.TextListModel", [], TextListModel, () => [["TextInfoList", Remote$1_$reflection(list_type(string_type))]]);
}

export class TextEditModel extends Record {
    constructor(Key, Content, Sending, IsDirty, TextAsHtml, MaintenanceActive) {
        super();
        this.Key = Key;
        this.Content = Content;
        this.Sending = Sending;
        this.IsDirty = IsDirty;
        this.TextAsHtml = TextAsHtml;
        this.MaintenanceActive = MaintenanceActive;
    }
}

export function TextEditModel_$reflection() {
    return record_type("AdminText.Types.TextEditModel", [], TextEditModel, () => [["Key", string_type], ["Content", FormField_$reflection()], ["Sending", bool_type], ["IsDirty", bool_type], ["TextAsHtml", string_type], ["MaintenanceActive", bool_type]]);
}

export function TextListModel_get_Init() {
    return new TextListModel(new Remote$1(1, []));
}

export function TextEditModel_Init_Z721C83C5(key) {
    return new TextEditModel(key, FormField_Init_Z1F39563A(new ValidationRule(0, [])), false, false, "", false);
}

export function TextEditModel__get_CanSubmit(x) {
    if (!x.Sending) {
        return FormField__get_IsValid(x.Content);
    }
    else {
        return false;
    }
}

//# sourceMappingURL=Types.fs.js.map
